/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import ElectroSelectExtra from 'forms/components/inputs/ElectroSelectExtra/ElectroSelectExtra';
import ElectroRadioGroup from 'forms/components/inputs/ElectroRadioGroup/ElectroRadioGroup';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import AutoCompleteModel from 'models/forms/AutoCompleteModel';

import { autoCompleteManufacturers } from 'api/forms.js';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

type TypeProps = {|
  form: Object,
  itemData: Object,
  setMode: Function,
  inEditMode: boolean,
|};

@observer
export default class ManufacturerAdditionRequest extends React.Component<*> {
  @observable manufacturerModel: AutoCompleteModel = new AutoCompleteModel(
    autoCompleteManufacturers
  );

  render(): React.Element<*> {
    const { form, itemData, setMode, inEditMode }: TypeProps = this.props;

    return (
      <div>
        <ElectroSelectExtra
          isFlex={true}
          field={form.$('manufacturerAddition.name')}
          form={form}
          formName="manufacturerAddition"
          labelKey="name"
          valueKey="id"
          disabled={!inEditMode}
          onSetEdit={() => {
            setMode(true);
            form.$('manufacturerAddition.inEditMode').value = true;
          }}
          onResetFunc={() => {
            setMode(false);
            form.$('manufacturerAddition.inEditMode').value = false;
          }}
          props={{
            model: this.manufacturerModel,
            itemData: itemData.fields,
          }}
        />
        <ElectroTextField field={form.$('manufacturerAddition.code')} disabled={inEditMode} />
        <ElectroTextField field={form.$('manufacturerAddition.short_code')} disabled={inEditMode} />
        <ElectroRadioGroup
          field={form.$('manufacturerAddition.key_oem')}
          inline={true}
          isBoolean={true}
          disabled={inEditMode}
        />
      </div>
    );
  }
}
